module.exports = __webpack_public_path__ + "img/5.4ec97f7b.jpg";